import Vue from 'vue';
import Config from './myconfig.js';
export const showAppdownload = 1;
export const friend_time = function (t) {
    var now = Math.floor(Date.now())/1000;
    var that= Math.floor(new Date(t))/1000;
    var minutes = (now-that)/60;
    var hours = minutes/60;
    var days = hours/24;
    if (minutes ==0) {
        minutes = 1;
    }

    if (minutes<60) {
        return Math.floor(minutes) + "分钟前";
    } else {
        if (hours<24) {
            return Math.floor(hours) + "小时前";
        } else {
            if (days<3) {
                return Math.floor(days) + "天前";
            } else {
                return t;
            }
        }
    }
}
export const secondToTime=function(result) {
	var day = Math.floor( result/ (24*3600) );
    var h = Math.floor(result / 3600) < 10 ? '0'+Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
    if(day>=1){
    	return day+'天';
    }
    return result = h + ":" + m + ":" + s;
}
export const getToken = function () {
    var s = localStorage.getItem('token');
    try {
//      var user = JSON.parse(s);
//      return (user || {}).user_token
		return JSON.parse(s);
    } catch (e) {
        return null;
    }
}
export const clearToken = function () {
    localStorage.removeItem('token');
}
export const getData = function (url, done, fail) {
    var enableCache = false;
    var url =  Config.server + url ;
    // var url =  url ;

    if (getCacheData(url)) {
        var cache = getCacheData(url);
        if (cache) {
            console.log ('get cache data for url ' + url);
            done(cache.data);
            return;
        }
    }

    Vue.http.get(url).then( function (resp) {
        var res = resp.body;
        if (enableCache && res && resp.status == 200) {
            setCacheData(url, {data:res});
        }
		 if(res.errorcode>=10000){
        	clearToken();
        	window.location.href='/pc/#/account/login';
			// window.location.reload();
        	return false;
        }
        done(res);
    }, function (resp) {
        if(resp.status>400){
            alert("接口错误");
        }else if (resp.status != 200){
            fail();
        }
    });
}

export const postData = function (url, data, done, fail) {
    var url = Config.server + url;
    Vue.http.post(url, data).then( function (resp) {
    	var res = resp.body;
            done(res)
      }, function (resp) {
            if (resp.status == 401) {
                alert('超时，请重新登录');
                window.location.reload();
            } else {
                fail();
            }
    });
}
export const get_cache_item = function (key) {
    var s = localStorage.getItem(key);
    try {
        var user = JSON.parse(s);
        return user;
    } catch (e) {
        return null;
    }
}

export const set_cache_item = function (key, value) {
    var s = JSON.stringify(value);
    localStorage.setItem(key, s);
    return true;
}
export const getCacheData = function (key, default_value) {
    var s = localStorage.getItem('info') ;
    var now = getTime();
    var cache_seconds = 3000;
    try {
        var temp = JSON.parse(s);
        if (temp) {
            var tmp_value = temp[key];
            if (tmp_value) {
                if (tmp_value.value && tmp_value.created_at && (now - tmp_value.created_at < cache_seconds) ) {
                    return tmp_value.value;
                }
            }
            return  default_value;
        }
    } catch (e) {
        return null;
    }
}

export const setCacheData = function (key, value) {
    var tmp = {'created_at': getTime(), 'value': value};
    var s = localStorage.getItem('info') ;
    var data = {};
    try {
        var temp = JSON.parse(s);
        if (temp) {
            temp[key] = tmp;
            data = temp; 
        } else {
            // empty 
            var temp_empty = {};
                temp_empty[key] = tmp;
            data = {'info': temp_empty};
        }
    } catch (e) {
        console.log ('set cache data fail ');
        console.log (e);
        var temp_empty = {};
            temp_empty[key] = tmp;
        data = {'info': temp_empty};
    }
    localStorage.setItem('info', JSON.stringify(data));
}
function getTime () {
    return (new Date().getTime())/1000;
}
export const loading=function(){
	
}



//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = null
// module chunks = 